import cx from 'classnames';
import PropTypes from 'prop-types';
import { useFocused, useSelected } from 'slate-react';

import { useStyles } from './useStyles';

export const ImageNode = ({ element, children, attributes }) => {
  const styles = useStyles();

  const selected = useSelected();
  const focused = useFocused();

  return (
    <>
      <div
        className={cx(styles.root, {
          [styles.highlighted]: selected && focused,
        })}
        {...attributes}
      >
        {children}
        <img
          className={styles.image}
          src={element.src}
        />
      </div>
    </>
  );
};

ImageNode.propTypes = {
  attributes: PropTypes.shape({}),
  element: PropTypes.shape().isRequired,
  children: PropTypes.node,
};

ImageNode.defaultProps = {
  attributes: {},
  children: null,
};
